import React from "react";
import { Field } from "formik";
import { OpportunityForm, SearchSelect, ChipGroup, Grid, makeStyles } from "../../../.."; // import PropTypes from 'prop-types';

import selects from "../../../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      padding: "20px"
    },
    flex: {
      display: "flex",
      "flex-direction": "column",
      "justify-content": "space-between"
    },
    mr30: {
      "margin-right": "30px",
      width: "50%"
    },
    estimatedValue: {
      display: "flex",
      "flex-direction": "row",
      "align-items": "center",
      height: "auto"
    }
  };
});

var B2BProjectForm = function B2BProjectForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode,
      contacts = _ref.contacts,
      opportunities = _ref.opportunities,
      fillForm = _ref.fillForm,
      translation = _ref.translation,
      currency = _ref.currency,
      fromBestPractice = _ref.fromBestPractice;
  var classes = useStyles();

  var contentHandler = function contentHandler(value) {
    switch (value) {
      case "opportunity":
        return [mode === "add" && /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Field, {
          name: "opportunity",
          label: translation ? translation.selects.opportunity.placeholder : "Opportunity",
          className: classes.mr30,
          component: SearchSelect,
          placeholder: translation ? translation.selects.opportunity.placeholder : "Opportunity",
          margin: "normal",
          value: values.opportunity,
          options: opportunities,
          fillForm: fillForm,
          clickable: mode !== "view"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(OpportunityForm, {
          translation: translation ? translation : null,
          values: values,
          mode: "add",
          type: "service",
          currency: currency,
          fromBestPractice: fromBestPractice
        }))];

      default:
        return /*#__PURE__*/React.createElement(OpportunityForm, {
          translation: translation ? translation : null,
          values: values,
          mode: mode,
          type: "service",
          contacts: contacts,
          currency: currency,
          fromBestPractice: fromBestPractice
        });
    }
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, mode === "add" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Field, {
    name: "source",
    label: translation ? translation.selects.project_source.placeholder : "Do you want to create your project from a won opportunity?",
    component: ChipGroup,
    placeholder: translation ? translation.selects.project_source.placeholder : "Do you want to create your project from a won opportunity?",
    margin: "normal",
    value: values.source,
    options: translation ? translation.selects.project_source.items : [{
      label: "Yes",
      value: "opportunity"
    }, {
      label: "No, I want to create a new project",
      value: "new"
    }],
    clickable: mode !== "view"
  })), contentHandler(values.source), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Field, {
    name: "statusExecution",
    placeholder: translation ? translation.selects.status.placeholder : "Status",
    label: translation ? translation.selects.status.placeholder : "Status",
    className: classes.fullWidth,
    component: ChipGroup,
    margin: "normal",
    value: values.statusExecution,
    options: translation ? translation.selects.status.items : selects.project_status,
    clickable: mode !== "view"
  })));
}; // B2BProjectForm.propTypes = {
// 	/** Values coming from Formik*/
// 	values: PropTypes.object,
// 	/** Mode to be render. If 'add' content can be added, if 'edit', previous content would be loaded and can be edited, if 'view' no edit option is allowed */
// 	mode: PropTypes.oneOf([ 'edit', 'view', 'add' ])
// };
// B2BProjectForm.defaultProps = {
// 	mode: 'add'
// };


export { B2BProjectForm };